
import { MovieStats } from '../types/movie';
import { Film, BarChart3 } from 'lucide-react';

interface HeaderProps {
  stats: MovieStats;
  onShowStats: () => void;
}

export const Header: React.FC<HeaderProps> = ({ stats, onShowStats }) => {
  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-md shadow-sm border-b border-gray-200/70">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 sm:py-6 space-y-4 sm:space-y-0">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="p-1.5 sm:p-2 rounded-xl bg-gradient-to-br from-primary-600 to-primary-800 shadow-sm shadow-primary-600/30">
              <Film className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
            </div>
            <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-gray-900 to-primary-800 bg-clip-text text-transparent">Malés' Movies</h1>
          </div>

          <div className="w-full sm:w-auto">
            <div className="grid grid-cols-2 sm:flex sm:items-center sm:space-x-4 lg:space-x-6 gap-3 sm:gap-0">
              <div className="text-center">
                <div className="text-lg sm:text-2xl font-bold text-gray-900">{stats.totalMovies}</div>
                <div className="text-xs sm:text-sm text-gray-500">Movies Watched</div>
              </div>

              <div className="text-center">
                <div className="text-lg sm:text-2xl font-bold text-green-600">{stats.averageScore}</div>
                <div className="text-xs sm:text-sm text-gray-500">Avg Score</div>
              </div>

              <div className="text-center">
                <div className="text-lg sm:text-2xl font-bold text-red-500">{stats.moviesWithGF}</div>
                <div className="text-xs sm:text-sm text-gray-500">With GF</div>
              </div>

              <div className="text-center">
                <div className="text-lg sm:text-2xl font-bold text-primary-600">{stats.moviesAbove7}</div>
                <div className="text-xs sm:text-sm text-gray-500">Above 7</div>
              </div>
            </div>

            <div className="mt-3 sm:mt-0 sm:ml-4">
              <button
                onClick={onShowStats}
                className="w-full sm:w-auto btn-primary flex items-center justify-center space-x-2 text-sm sm:text-base py-2 px-3 sm:px-4"
              >
                <BarChart3 className="h-4 w-4" />
                <span>More Statistics</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
